import { store } from "../store/index";
import {
  filterExpeditionProcess,
  createExpeditionProcess,
  getProcess,
  bbsNew,
  modifyProcess,
  itemRemove,
  check,
} from "../store/actions/expeditionProcessActions";
import { PROCESS_EXPEDITION_CLOSED, PROCESS_EXPEDITION_STARTED } from "../constants";

/**
 * List Inventary
 */
export const listFilterExpeditionProcess = async (filter) => {
  const result = await store.dispatch(filterExpeditionProcess(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List export data
 */
// export const listToExport = async (uuid) => {
//   const result = await store.dispatch(listExpeditionProcessToExport(uuid));
//   if (result && result.payload && result.payload.data) {
//     return result.payload.data;
//   }
//   return null;
// };

export const newExpeditionProcess = async (values) => {
  const result = await store.dispatch(createExpeditionProcess(values));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const addBBs = async (values, param) => {
  const result = await store.dispatch(bbsNew(values, param));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const processGetService = async (uuid) => {
  const result = await store.dispatch(getProcess(uuid));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const modifyStatusProcess = async (uuid, statusObj) => {
  const result = await store.dispatch(modifyStatusProcess(uuid, statusObj));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};


export const deleteItemProcess = async (batch) => {
  const result = await store.dispatch(itemRemove(batch));
  if (result) {
    return result;
  }
  return null;
};


export const checkBBs = async (values) => {
  const result = await store.dispatch(check(values));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const updateProcess = async (values, uuid) => {
  const result = await store.dispatch(modifyProcess(uuid, values));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};